class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


///////////////////////////////////////////////////////////////////////////////////////////////////////////////
// sidecart upsells 2024-02-15
///////////////////////////////////////////////////////////////////////////////////////////////////////////////

function ReallyUpdateSidecart( )
{
    fetch( window.location.href, { "method"  : 'GET' } ).then( function( response )
    {
        response.text( ).then( function( markup )
        {
            var parser = document.createElement( "div" );
            parser.innerHTML = markup;

            var updated = parser.querySelector( "#CartDrawer" );
            var onPage  = document.querySelector( "#CartDrawer" );

            onPage.parentNode.appendChild( updated );
            onPage.remove( );
        } );
    } );
}

function RunSidecartUpsell( e )
{    
    var element = e.currentTarget;

    var updates = { };
    updates[ element.getAttribute( "data-item-id" ) ] = 0;

    fetch( window.Shopify.routes.root + 'cart/update.js',
    {
        "method"  : 'POST',
        "headers" :
        {
            'Content-Type': 'application/json'
        },
        "body" : JSON.stringify( { updates } )

    } ).then( function( response2 )
    {
        var add =
        {
            "items" :
            [
            {
                "id"           : element.getAttribute( "data-variant_id" ),
                "selling_plan" : element.getAttribute( "data-sellingplan" ),
                "quantity"     : 1
            }
            ]
        };
        fetch ( window.Shopify.routes.root + 'cart/add.js',
        {
            "method"  : 'POST',
            "headers" :
            {
                'Content-Type': 'application/json'
            },
            "body" : JSON.stringify( add )
        
        } ).then( function( response )
        {
            console.log( "cart updated" );

            publish( PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: add.id, cartData: response } );
            if ( element.classList.contains( "numind-subscribe-sidecart" ) )
            {
                console.log( "update sidecart" );
                ReallyUpdateSidecart( );
            }
        
        } ).catch( function( error )
        {
            console.error( 'Error:', error );
        } );

    } ).catch( function( error )
    {
        console.error( 'Error2:' , error );
    } );
}

function SetUpsellEventHandlers( )
{
    var buttons = document.querySelectorAll( ".rc-custom-widget-sidecart" );
    console.log( "set event handlers on ", buttons );
    buttons.forEach( function( button )
    {
        button.removeEventListener( "click", RunSidecartUpsell );
        button.addEventListener( "click", RunSidecartUpsell );
    } );    
}

function StartupSidecartUpsellHandling( )
{
    SetUpsellEventHandlers( );

    console.log( "sidecart watch starting" );
    var watch = document.querySelector( "body" );
    var debouncer;
    var observer = new MutationObserver( function( )
    {
        if ( debouncer )
        {
            clearTimeout( debouncer );
        }
        debouncer = setTimeout( function( )
        {
            observer.disconnect( );
            observer.takeRecords( );
            console.log( "sidecart changed" );
            SetUpsellEventHandlers( );
            observer.observe( watch, { childList: true, attributes: true, subtree: true } );
        }, 100 );
    } );
    observer.observe( watch, { childList: true, attributes: true, subtree: true } );
}

window.addEventListener( "load", StartupSidecartUpsellHandling );


